import {Component, Input, OnInit} from '@angular/core';
import {routerTransition} from '@app/router.animations';
import {CommonModule} from '@angular/common';
import moment from 'moment';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {FormsModule} from '@angular/forms';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {ReportService} from '@app/shared/services/report.service';
import {ToastrService} from 'ngx-toastr';
import EmailValidator from 'email-validator';
import {environment} from '@env/environment';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {OnlyNumberDirective} from '@app/shared/directive';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {UtilsInjectable} from '@app/shared';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.scss'],
  animations: [routerTransition()],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    SelectDropDownModule,
    OnlyNumberDirective,
    NgbPaginationModule,
    PaginationComponent,

  ]
})
export class VendorComponent implements OnInit {
  @Input() assessment_id = 0;
  @Input() patient_id = 0;
  public now = new Date();
  public date: any;
  public user_rights: any = {};
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  public user_data: any = {};
  public splitted: any = [];
  public vendor_data: any =
    {
      vendor_code: 'VC-000001',
      vendor_name: '',
      user_id: '',
      vendor_address: '',
      vendor_phoneno: '',
      vendor_email: '',
      payment_type: 1,
      search_vendor: '',
      credit_period: '',
      file_name: '',
      vendor_vat: '',
      vendor_id: 0,
      state: '',
      document: ''
    }

  index: any;
  public vendors_data: any = [];
  status: any;
  public fileName: any = '';
  public image: any = "";
  states: any;
  state_options: any;

  constructor(private loaderService: LoaderService,
              public consultingService: ConsultingService,
              public reportService: ReportService,
              protected utils: UtilsInjectable,
              private toastr: ToastrService) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.vendor_data.user_id = this.user_data.user_id;
    this.formatDateTime();
    this.getVendorList();
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  public saveVendor(): any {
    if (this.vendor_data.vendor_name == "") {
      this.toastr.error('Please enter the Supplier name!')
      return false;
    }
    if (this.vendor_data.vendor_email != '') {
      if (!EmailValidator.validate(this.vendor_data.vendor_email)) {
        this.toastr.error('Please enter proper email !');
        return false;
      }
    }
    if (this.image != '') {
      this.splitted = this.image.split(",");
    }
    if (this.fileName == "") {
      this.splitted[1] = ''
    }
    const postData = {
      user_id: this.user_data.user_id,
      vendor_id: this.vendor_data.vendor_id,
      vendor_code: this.vendor_data.vendor_code,
      vendor_name: this.vendor_data.vendor_name,
      vendor_address: this.vendor_data.vendor_address,
      vendor_phoneno: this.vendor_data.vendor_phoneno,
      vendor_email: this.vendor_data.vendor_email,
      state: this.vendor_data.state,
      base64_file_str: this.splitted[1],
      payment_type: this.vendor_data.payment_type,
      credit_period: this.vendor_data.credit_period,
      vendor_trn: this.vendor_data.vendor_vat,
      file_name: this.fileName
    }
    this.loaderService.display(true);
    this.consultingService.saveVendor(postData).subscribe((result: any) => {
      window.scrollTo(0, 0)
      this.vendor_data.vendor_code = result.vendor_code;
      if (result["status"] == "Success") {
        this.toastr.success(result.msg);
        this.getVendorList();
        this.clearvendor();
        this.index = result.data_id;
      } else {
        this.toastr.error(result.msg);
      }
      this.loaderService.display(false);
    })
  }

  public removeFile() {
    this.fileName = ""
  }

  public filePath(filename: any) {
    let path: string;
    path = environment.DOCUMENT_UPLOAD_PATH + filename;
    return path;
  }

  public selectCoinPaymentType(val: any) {
    this.vendor_data.payment_type = val;
  }

  public getVendor() {
    const post2Data = {
      vendor_id: this.vendor_data.vendor_id
    }
    this.loaderService.display(true);
    this.consultingService.getVendor(post2Data).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.vendors_data = result['data'];
        this.loaderService.display(false);
      }
    });
  }

  public clearvendor() {
    this.vendor_data = {
      vendor_name: '',
      user_id: '',
      vendor_address: '',
      vendor_phoneno: '',
      vendor_email: '',
      payment_type: 1,
      search_vendor: '',
      credit_period: '',
      file_name: '',
      vendor_vat: '',
      vendor_id: 0
    }
    this.vendor_data.state = this.state_options[18].STATE_ID;
    this.vendor_data.vendor_id = 0;
    this.fileName = "";
    this.getVendorList();
  }

  public getVendorList(page = 1) {
    this.page = page;
    const limit = 50;
    this.start = (page-1) * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      vednor_id: '0'
    };
    this.loaderService.display(true);
    this.consultingService.Vendors(postData).subscribe((result: any) => {
      this.vendor_data.vendor_code = result['vendor_code']['data'];
      if (result['status'] == 'Success') {
        this.vendors_data = result['data'];
        this.collection = result['total_count'];
      } else {
        this.collection = 0;
      }
      this.loaderService.display(false);
    });
  }

  public clear_search() {
    if (this.vendor_data.search_vendor != '') {
      this.clearvendor();
      this.getVendorList();
    }
  }

  getFileDetails($event: any) {
    const file = $event.target.files[0];
    this.fileName = file.name;
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    const file: File = inputValue.files[0];
    const myReader: FileReader = new FileReader();

    myReader.onloadend = () => {
      this.image = myReader.result;
    }
    myReader.readAsDataURL(file);
  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.vendor_data.search_vendor,
      vendor_id: '0'
    };
    this.loaderService.display(true);
    this.consultingService.Vendors(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.vendors_data = result['data'];
        this.collection = result['total_count'];
        const i = this.vendors_data.length;
        this.index = i + 5;
        this.status = result['status'];
      }
      this.loaderService.display(false);
    });
  }

  public editVendor(vendor: any) {
    this.vendor_data.vendor_code = vendor.VENDOR_CODE;
    this.vendor_data.vendor_name = vendor.VENDOR_NAME;
    this.vendor_data.vendor_address = vendor.VENDOR_ADDRESS;
    this.vendor_data.vendor_phoneno = vendor.VENDOR_PHONE;
    this.vendor_data.credit_period = vendor.CREDIT_PERIOD;
    this.vendor_data.payment_type = vendor.PAYMENT_TYPE;
    this.vendor_data.vendor_email = vendor.VENDOR_EMAIL;
    this.vendor_data.vendor_vat = vendor.TRN_NO;
    this.fileName = vendor.VENDOR_DOCUMENT;
    this.vendor_data.vendor_id = vendor.VENDOR_ID;
    this.vendor_data.state = vendor.VENDOR_STATE;
    window.scrollTo(0, 0);
  }

  public formatDateTime() {
    if (this.now) {
      this.date = moment(this.now, 'yyyy-MM-D HH:mm.ss a').format('D-MM-Y h:mm a');
    }
  }

  deleteVendor(vend_id:any){
    const confirmed = confirm('Are you sure you want to delete this supplier?');
    if (confirmed) {
      this.loaderService.display(true);
      this.consultingService.deleteVendor({vendor_id : vend_id}).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.getVendorList();
          this.toastr.success(result["msg"]);
        }else{
          this.toastr.error(result["msg"]);
        }
        this.loaderService.display(false);
      });
    }
  }

}
